module.exports = __webpack_public_path__ + "static/media/strong36.ed92b955.jpg";